"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateYAxisValues = exports.YAxisLabels = exports.StyledLabelWrapper = exports.StyledBar = exports.StyledSingleBarWrapper = exports.StyledBarGraphWrapper = exports.StyledBarGraphCollectionWrapper = exports.StyledBarGraphContainer = exports.CONTAINER_PADDING = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var __1 = require("../../../..");
exports.CONTAINER_PADDING = 10;
var barColor = __1.colors2.secondaryContainer; // temp color
var grey5 = __1.colors2.grey5;
exports.StyledBarGraphContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", "px;\n    padding-bottom: 0.4rem; // UI scroll bar bottom space \n    overflow-x: auto;\n    background-color: white;\n    border-radius: 8px;\n"], ["\n    padding: ", "px;\n    padding-bottom: 0.4rem; // UI scroll bar bottom space \n    overflow-x: auto;\n    background-color: white;\n    border-radius: 8px;\n"])), exports.CONTAINER_PADDING);
exports.StyledBarGraphCollectionWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n"], ["\n    display: flex;\n"])));
exports.StyledBarGraphWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    position: relative;\n\n  "], ["\n    display: flex;\n    position: relative;\n\n  "])));
var generateDebugLines = function (barSections, debug) {
    if (!debug)
        return '';
    var lines = [];
    for (var i = 1; i <= barSections; i++) {
        lines.push('linear-gradient(to right, #383838 0%, #383838 100%)');
    }
    var positions = [];
    for (var i = 0; i <= barSections; i++) {
        var position = (100 / barSections) * i;
        positions.push("0 ".concat(position, "%"));
    }
    return "\n        &::before {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background-image: ".concat(lines.join(', '), ";\n            background-size: ").concat(Array(barSections).fill('100% 1px').join(', '), ";\n            background-position: ").concat(positions.join(', '), ";\n            background-repeat: no-repeat;\n            pointer-events: none;\n            z-index: 0;\n        }\n    ");
};
exports.StyledSingleBarWrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    height: 100%;\n    display: flex;\n    align-items: flex-end;\n    position: relative;\n    cursor: pointer;\n    border-radius: 2px;\n\n    &:hover {\n       background-color: ", ";\n    }\n\n    ", "\n    \n    > * {\n        position: relative;\n        z-index: 1;\n    }\n"], ["\n    height: 100%;\n    display: flex;\n    align-items: flex-end;\n    position: relative;\n    cursor: pointer;\n    border-radius: 2px;\n\n    &:hover {\n       background-color: ", ";\n    }\n\n    ", "\n    \n    > * {\n        position: relative;\n        z-index: 1;\n    }\n"])), grey5, function (_a) {
    var barSections = _a.barSections, debug = _a.debug;
    return generateDebugLines(barSections, debug);
});
exports.StyledBar = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    border-radius: 2px;\n    background-color: ", ";\n    color: ", ";\n    position: relative;\n    ", ";\n"], ["\n    border-radius: 2px;\n    background-color: ", ";\n    color: ", ";\n    position: relative;\n    ", ";\n"])), barColor, __1.colors2.onSecondary, (0, __1.transition)("width"));
exports.StyledLabelWrapper = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    position: absolute;\n    transform: rotate(-90deg);\n    transform-origin: left top;\n    bottom: 0;\n    left: calc(50% - 8px); // 10px for font\n    text-wrap: nowrap;\n    display: flex;\n"], ["\n    position: absolute;\n    transform: rotate(-90deg);\n    transform-origin: left top;\n    bottom: 0;\n    left: calc(50% - 8px); // 10px for font\n    text-wrap: nowrap;\n    display: flex;\n"])));
exports.YAxisLabels = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  height: inherit;\n  display: flex;\n\n  flex-direction: column-reverse;\n  justify-content: space-between;\n\n  color: ", ";\n  z-index: 100;\n"], ["\n  height: inherit;\n  display: flex;\n\n  flex-direction: column-reverse;\n  justify-content: space-between;\n\n  color: ", ";\n  z-index: 100;\n"])), __1.colors2.grey50);
var generateYAxisValues = function (barDivisions) {
    // For 5 labels, we want to divide the range into 4 equal parts
    var numLabels = 5;
    var step = barDivisions / (numLabels - 1);
    var values = [];
    for (var i = 0; i < numLabels; i++) {
        values.push(Math.round(step * i));
    }
    // Ensure the last value is exactly barDivisions to avoid rounding errors
    values[values.length - 1] = barDivisions;
    var uniqueValues = [];
    var seen = new Set();
    for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
        var value = values_1[_i];
        if (!seen.has(value)) {
            uniqueValues.push(value);
            seen.add(value);
        }
    }
    return uniqueValues;
};
exports.generateYAxisValues = generateYAxisValues;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
